export const DOWNLOADING_DOCUMENT = 'Downloading Document';
export const UPLOADING_DOCUMENT = 'Uploading Document';
export const UPLOADING_DOCUMENTS = 'Uploading Documents';
export const CANCELLING_VIDEO_UPLOAD = 'Cancelling Video Upload';
